<template>
    <div class="vx-card p-8">
        <h3>Tạo chính sách nghỉ phép</h3>
        <div class="vx-row">
            <div class="vx-col w-full md:w-3/12 mt-4">
                <label class="vs-input--label">Tên chính sách</label>
                <span class="text-danger">*</span>
                <vs-input class="w-full" v-model="policy.name" v-validate="'required'" name="Chính sách"></vs-input>
                <span class="text-danger text-sm">{{ errors.first('Chính sách') }}</span>
            </div>
            <div class="vx-col w-full md:w-3/12 mt-4">
                <label class="vs-input--label">Mã chính sách</label>
                <span class="text-danger">*</span>
                <vs-input class="w-full" v-model="policy.code" v-validate="'required'" name="Mã chính sách"></vs-input>
                <span class="text-danger text-sm">{{ errors.first('Mã chính sách') }}</span>
            </div>
            <div class="vx-col w-full md:w-3/12 mt-4">
                <label class="vs-input--label">Loại chính sách</label>
                <span class="text-danger">*</span>
                <v-select class="w-full" v-model="policyTypeModel" name="Loại chính sách" :clearable="false"
                    :options="policyTypeOptions" v-validate="'required'">
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('Loại chính sách') }}</span>
            </div>
            <div class="vx-col w-full md:w-3/12 mt-4">
                <label class="vs-input--label">Số lượng phép chuẩn hàng năm</label>
                <span class="text-danger">*</span>
                <vs-input class="w-full" v-model="policy.annualLeave" v-validate="'required|min_value:0|numeric'"
                    type="number" step="1" min="0" name="Số lượng phép chuẩn hàng năm"></vs-input>
                <span class="text-danger text-sm">{{ errors.first('Số lượng phép chuẩn hàng năm') }}</span>
            </div>
        </div>
        <!-- <div class="vx-row">
            <div class="vx-col w-full md:w-4/12 mt-4">
                <label class="vs-input--label">Số lượng nghỉ phép tối đa</label>
                <span class="text-danger">*</span>
                <vs-input class="w-full" v-model="policy.maximalLeave" v-validate="'required|numeric'" name="Số lượng phép tối đa"></vs-input>
                <span class="text-danger text-sm">{{ errors.first('Số lượng phép tối đa') }}</span>
            </div>
        </div> -->
        <div class="vx-row">
            <div class="vx-col w-full mt-5 quill-editor">
                <label class="vs-input--label">Miêu tả chính sách</label>
                <span class="text-danger">*</span>
                <quill-editor class="input-description" v-model="policy.description" v-validate="'required'"
                    name="Miêu tả chính sách"></quill-editor>
                <span class="text-danger text-sm">{{ errors.first('Miêu tả chính sách') }}</span>
            </div>

        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-5 flex flex-wrap items-center justify-end">
                    <vs-button color="primary" type="border" class="ml-auto" @click="saveOnLeave"
                        :disabled="!validateForm">Tạo mới</vs-button>
                    <vs-button vs-button color="primary" type="border" class="ml-4" @click="goBack">Quay lại
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select'
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor'

export default {

    components: {
        vSelect,
        quillEditor
    },

    data() {
        return {
            policy: {
                type: null,
            },
            policyTypeOptions: [
                { value: 0, label: 'Cố định' },
                { value: 1, label: 'Thay đổi theo tháng' },
            ],
        }
    },

    created() {

    },

    computed: {
        validateForm() {
            return !this.errors.any()
        },

        policyTypeModel: {
            get() {
                let x = this.policyTypeOptions.find(item => item.value == this.policy.type);
                if (!x) {
                    return
                }
                return {
                    label: x.label,
                    value: x.value
                }
            },
            set(obj) {
                this.policy.type = obj.value;
            }
        }
    },

    methods: {

        goBack() {
            this.$router.go(-1);
        },

        async saveOnLeave(el) {

            el.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            this.$vs.loading();
            this.$crm.post('/policy/create', this.policy).then((response) => {
                this.$vs.notify({
                    title: 'Thành công',
                    text: 'Tạo chính sách nghỉ phép thành công',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                this.$vs.loading.close();
                this.$router.go(-1);
            }).catch((error) => {
                this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Tạo chính sách nghỉ phép thất bại',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$vs.loading.close();
            });



        },
    }

}
</script>

<style scoped>
.input-description {
    min-height: 100px !important;
}
</style>
